module.exports = __webpack_public_path__ + "static/assets/2c56724ec05c87153454a4ef8c7f48bd.svg";